export default __webpack_public_path__ + "static/media/whyBrokerVTGMIcon3.fc7c7871.webp";